module.exports = __webpack_public_path__ + "img/lightning-fill.46e7472a.svg";